var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureI(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 17.2383V21.2383H28.9375V33.2383H30.9375V37.2383H22.9375V33.2383H24.9375V21.2383H22.9375V17.2383H30.9375ZM26.9375 7.23828C29.5639 7.23828 32.1647 7.7556 34.5912 8.76069C37.0177 9.76578 39.2225 11.239 41.0796 13.0961C42.9368 14.9533 44.41 17.1581 45.4151 19.5846C46.4202 22.0111 46.9375 24.6118 46.9375 27.2383C46.9375 32.5426 44.8304 37.6297 41.0796 41.3804C37.3289 45.1311 32.2418 47.2383 26.9375 47.2383C24.3111 47.2383 21.7103 46.721 19.2838 45.7159C16.8573 44.7108 14.6525 43.2376 12.7954 41.3804C9.04464 37.6297 6.9375 32.5426 6.9375 27.2383C6.9375 21.934 9.04464 16.8469 12.7954 13.0961C16.5461 9.34542 21.6332 7.23828 26.9375 7.23828ZM26.9375 11.2383C22.694 11.2383 18.6244 12.924 15.6238 15.9246C12.6232 18.9252 10.9375 22.9948 10.9375 27.2383C10.9375 31.4817 12.6232 35.5514 15.6238 38.552C18.6244 41.5526 22.694 43.2383 26.9375 43.2383C31.181 43.2383 35.2506 41.5526 38.2512 38.552C41.2518 35.5514 42.9375 31.4817 42.9375 27.2383C42.9375 22.9948 41.2518 18.9252 38.2512 15.9246C35.2506 12.924 31.181 11.2383 26.9375 11.2383Z",
    fill: "#8F4300",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78906 50.9688L50.7278 3.02999",
    stroke: "#8F4300",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureI);
export default __webpack_public_path__ + "static/media/Feature_I.2f57f357625b3afd1a5f7158fbe28ece.svg";
export { ForwardRef as ReactComponent };